import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import LoanMappingListUI from './LoanMappingListUI.js'

class LoanMappingListSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            mappingList: null,
            createMode: false,
            updateMode: false,
            selectedMapping: null,
        }
    }

    render() {
        return (
            <LoanMappingListUI
                context={this.props.context}
                errorList={this.state.errorList}
                mappingList={this.state.mappingList}
                selectedMapping={this.state.selectedMapping}
                createMode={this.state.createMode}
                updateMode={this.state.updateMode}
                category={this.props.category}
                categoryLabel={this.props.categoryLabel}
                loan={this.props.loan}
                // events
                onRefreshClick={this.onRefreshClick}
                onCreateClick={() => { this.setState({ createMode: true }) }}
                onUpdateClick={this.onUpdateClick}
                onCancelClick={this.onCancelClick}
                onUpdate={this.onUpdate}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getMappings(context)
    }

    getMappings(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/${this.props.match.params.loanId}/mappingGroups/security_cover`,
            cacheKey: CacheKeys.LoanMappings(this.props.match.params.loanId),
            callback: this.getMappingsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getMappingsCallback = (response) => {
        this.setState({ errorList: response.errorList, mappingList: response.mappingList })
    }

    onUpdateClick = (event) => {
        let loanMappingId = event.currentTarget.getAttribute('data-mapping-id')
        let selectedMapping = this.state.mappingList.filter(p => p.loanMappingId === loanMappingId)[0]
        this.setState({ updateMode: true, selectedMapping: selectedMapping })
    }

    onCancelClick = () => {
        this.setState({ createMode: false, updateMode: false, errorList: null })
    }

    onUpdate = () => {
        CacheManager.removeObject(CacheKeys.LoanMappings(this.props.match.params.loanId))
        this.setState({ mappingList: this.state.mappingList })
    }

    onRefreshClick = (noBusy) => {
        CacheManager.removeObject(CacheKeys.LoanMappings(this.props.match.params.loanId))
        if (noBusy === 'noBusy') {
          this.getMappings(this.props.context)
        }
        else {
          this.setState(
              {
                  mappingList: null,
                  errorList: null,
              }, this.getMappings(this.props.context)
          )
        }
    }
}

export default withRouter(LoanMappingListSF)
